module.exports = __webpack_public_path__ + "img/1276.8d68ba48.gif";